import {Form, Select, Tag} from "antd";
import {useMemo, useState} from "react";

export function StepTypeColorDropdown(props: {
  name: string,
  label: string,
  required?: boolean
}) {
  const [selected, setSelected] = useState<string>()
  const colorOpts = useMemo(() => {
    return [
      { label: 'Padrão', value: '#595959'},
      { label: 'Azul', value: '#2b4acb' },
      { label: 'Roxo', value: '#642ab5' },
      { label: 'Verde', value: '#49aa19' },
      { label: 'Magenta', value: '#cb2b83' },
      { label: 'Ciano', value: '#13a8a8' },
      { label: 'Beije', value: '#d89614' },
      { label: 'Lima', value: '#8bbb11' },
      { label: 'Amarelo', value: '#d8bd14' },
      { label: 'Vermelho', value: '#d32029' },
      { label: 'Vulcão', value: '#d84a1b' },
      { label: 'Laranja', value: '#d87a16' },
    ]
  },[])
  
  const rules = useMemo(() => {
    return props.required ? [{ required: true }] : undefined
  }, [props.required])
  
  console.log(selected)
  return (
    <Form.Item name={props.name} label={props.label} rules={rules} >
      <Select
        tagRender={props => (
          <Tag color={props.value}>{props.label}</Tag>
        )}
        onSelect={setSelected}
        style={{background: 'red', color: selected ?? 'inherit', fontWeight: 'bold !important'}}
      >
        {colorOpts.map(color => (
          <Select.Option  key={color.value} style={{background: color.value, color: 'white', margin: 1}}>
            {color.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}